import {defu} from 'defu'

const knowledgeHubDataCategories = new Map([
    ['PageKnowledgeHub', ['knowledge-hub', 'global-forms', 'form-labels', 'knowledge-hub-collections']],
    ['PageKnowledgeHubArticles', ['knowledge-hub', 'knowledge-hub-collections', 'filter-labels', 'form-labels']],
    ['PageKnowledgeHubDetail', ['knowledge-hub', 'global-forms', 'form-labels']]

])

const knowledgeHubApiEndpoints = new Map([
    ['knowledge-hub', '/api/v3/knowledge-hub_data/knowledge-hub'],
    ['knowledge-hub-collections', '/api/v3/knowledge-hub_data/knowledge-hub-collections']
])

export const useKnowledgeHubGlobalData = () => {
    const {
        labels,
        globalContentData,
        localeGlobalContentData,
        setGlobalContentData,
        generateDataPromisesForContentType
    } = useGlobalData()

    async function fetchGlobalDataForContentType(contentType: string, locale?: string) {
        const promises = generateDataPromisesForContentType(contentType, knowledgeHubDataCategories, knowledgeHubApiEndpoints, locale)
        const responses = await Promise.all(promises)

        let data = {}
        responses.forEach((r: any) => {
            data = defu(r, data)
        })

        setGlobalContentData(data)
    }

    return {
        labels,
        globalContentData,
        localeGlobalContentData,
        fetchGlobalDataForContentType
    }
}
